import React, { useEffect, useState, useCallback } from "react";
import { getAuth } from "firebase/auth";
import { useAuth } from "./AuthContext";
import "./AdminOffersConsole.css";

const API = process.env.REACT_APP_FLUENCY_SERVER;

export default function AdminOffersConsole() {
  const [offers, setOffers] = useState([]);
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [newOffer, setNewOffer] = useState({ name: "", type: "test_credit", amount: 1 });
  const { userRole } = useAuth();
  const auth = getAuth();

    const authedFetch = useCallback(async (url, opts = {}) => {
    const token = await auth.currentUser.getIdToken();
    const res = await fetch(url, {
        ...opts,
        headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...(opts.headers || {})
        }
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "error");
    return data;
    }, [auth]);

    const loadData = useCallback(async () => {
        try {
            setLoading(true);
            const [offersData, metricsData] = await Promise.all([
            authedFetch(`${API}/api/admin/offers`),
            authedFetch(`${API}/api/admin/metrics?days=7`)
            ]);
            setOffers(offersData.items || []);
            setMetrics(metricsData);
            setError(null);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }, [authedFetch]); // only re-create if auth object changes


  async function createOffer() {
    try {
      await authedFetch(`${API}/api/admin/offers`, {
        method: "POST",
        body: JSON.stringify(newOffer)
      });
      setNewOffer({ name: "", type: "test_credit", amount: 1 });
      await loadData();
    } catch (e) {
      alert("Create failed: " + e.message);
    }
  }

  async function toggleOffer(id, active) {
    try {
      await authedFetch(`${API}/api/admin/offers/${id}`, {
        method: "PATCH",
        body: JSON.stringify({ active })
      });
      await loadData();
    } catch (e) {
      alert("Update failed: " + e.message);
    }
  }

  useEffect(() => { loadData(); }, [loadData]);

  if (loading) return <div>Loading…</div>;
  if (error) return <div>Error: {error}</div>;
  
  if (userRole !== "admin") return <div>Not authorized</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>Admin Offers Console</h2>

      {/* Metrics */}
      {metrics && (
        <div style={{ display: "flex", gap: 20, marginBottom: 20 }}>
          <div><strong>Redemptions (7d):</strong> {metrics.redemptions.success}/{metrics.redemptions.total}</div>
          <div><strong>IELTS Uses:</strong> {metrics.ielts.consumptions} (credits: {metrics.ielts.byKind.testCredit}, plan: {metrics.ielts.byKind.plan}, tokens: {metrics.ielts.byKind.tokens})</div>
          <div><strong>Funnel:</strong> {metrics.funnel.redeemedUsers} → {metrics.funnel.redeemedAndConsumedUsers}</div>
        </div>
      )}

      {/* Offers Table */}
      <table
      className="admin-offers-table"
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: 20,
      }}
    >
      <thead>
        <tr style={{ backgroundColor: "#333" }}>
          <th style={{ color: "#fff", padding: "8px" }}>Name</th>
          <th style={{ color: "#fff", padding: "8px" }}>Type</th>
          <th style={{ color: "#fff", padding: "8px" }}>Amount</th>
          <th style={{ color: "#fff", padding: "8px" }}>Inventory</th>
          <th style={{ color: "#fff", padding: "8px" }}>Priority</th>
          <th style={{ color: "#fff", padding: "8px" }}>Active</th>
          <th style={{ color: "#fff", padding: "8px" }}>Start / End</th>
          <th style={{ color: "#fff", padding: "8px" }}></th>
        </tr>
      </thead>
      <tbody>
        {offers.map((o) => (
          <tr key={o.id} style={{ backgroundColor: "#1c1f24", color: "#eee" }}>
            <td>{o.name}</td>
            <td>{o.type}</td>
            <td>{o.amount}</td>
            <td>{o.inventoryRemaining}</td>
            <td>{o.priority}</td>
            <td>{o.active ? "Yes" : "No"}</td>
            <td>
              {o.startAt?.toDate ? o.startAt.toDate().toLocaleDateString() : ""} →{" "}
              {o.endAt?.toDate ? o.endAt.toDate().toLocaleDateString() : ""}
            </td>
            <td>
              <button onClick={() => toggleOffer(o.id, !o.active)}>
                {o.active ? "Deactivate" : "Activate"}
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
      {/* Create Offer */}
      <div style={{ marginTop: 20 }}>
        <h3>Create New Offer</h3>
        <input
          placeholder="Name"
          value={newOffer.name}
          onChange={e => setNewOffer({ ...newOffer, name: e.target.value })}
        />
        <select
          value={newOffer.type}
          onChange={e => setNewOffer({ ...newOffer, type: e.target.value })}
        >
          <option value="test_credit">Test Credit</option>
          <option value="plan_trial">Plan Trial</option>
          <option value="token_credit">Token Credit</option>
        </select>
        <input
          type="number"
          value={newOffer.amount}
          onChange={e => setNewOffer({ ...newOffer, amount: Number(e.target.value) })}
        />
        <button onClick={createOffer}>Create</button>
      </div>
    </div>
  );
}
